import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/layouts/Stack/stack';
import { css } from '@patternfly/react-styles';
export var Stack = function Stack(_a) {
  var _a$hasGutter = _a.hasGutter,
      hasGutter = _a$hasGutter === void 0 ? false : _a$hasGutter,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'div' : _a$component,
      props = __rest(_a, ["hasGutter", "className", "children", "component"]);

  var Component = component;
  return React.createElement(Component, Object.assign({}, props, {
    className: css(styles.stack, hasGutter && styles.modifiers.gutter, className)
  }), children);
};